"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const RadioButtonWrapper_1 = tslib_1.__importDefault(require("./RadioButtonWrapper"));
/**
 * @deprecated use {@link WCAGRadioGroup}
 */
class RadioGroupWrapper extends fmko_ts_common_1.Widget {
    constructor(...radioElements) {
        super();
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        this.wrap(radioElements);
    }
    wrap(radioElements) {
        this.wrapped = [];
        if (radioElements && radioElements.length > 0) {
            this.element = radioElements[radioElements.length - 1]; // Radio Group Wrapper needs an element for validation to work
        }
        radioElements.forEach((el) => {
            let wrapper = new RadioButtonWrapper_1.default(el);
            this.wrapped.push(wrapper);
            wrapper.addClickHandler(() => {
                if (this.value !== el) {
                    this.value = el;
                    fmko_ts_common_1.ValueChangeEvent.fire(this, this.value);
                }
            });
        });
    }
    setValue(value, fireEvents = false) {
        if (value !== this.value) {
            this.value = value;
            if (value) {
                value.checked = true;
            }
            else {
                // Null/undefined value -> Clear all radio buttons in group
                this.wrapped.forEach((radio) => radio.setValue(false));
            }
            if (fireEvents) {
                fmko_ts_common_1.ValueChangeEvent.fire(this, this.value);
            }
        }
    }
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
    getValue() {
        return this.value;
    }
    addOnBlurHandler(handler) {
        this.wrapped.forEach((radio) => radio.addOnBlurHandler(handler));
    }
    enable(enable) {
        this.wrapped.forEach(rb => rb.setEnabled(enable));
    }
}
exports.default = RadioGroupWrapper;
//# sourceMappingURL=RadioGroupWrapper.js.map